<template lang="pug">
  v-bottom-navigation.nav(v-if="$vuetify.breakpoint.mobile" v-model="activeTab" app fixed grow height="87px" background-color="white")
    .nav-button(value="insights" @click="navigateTo('/admin/hq/insights/today')")
      .nav-content
        v-icon(v-if="activeTab === 'insights'" :size="iconSize" color="neutral700") $yzi-bar-chart-square-solid-01
        v-icon(v-else :size="iconSize" color="neutral500") $yzi-bar-chart-square-line-01
        .nav-text(:class="[activeTab === 'insights' ? 'nav-text--active primary--text' : 'nav-text--default neutral500--text']") Insights

    .nav-button(value="inventory" @click="navigateTo('/admin/hq/inventory')")
      .nav-content
        v-icon(v-if="activeTab === 'inventory'" :size="iconSize" color="neutral700") $yzi-package-solid
        v-icon(v-else :size="iconSize" color="neutral500") $yzi-package
        .nav-text(:class="[activeTab === 'inventory' ? 'nav-text--active primary--text' : 'nav-text--default neutral500--text']") Inventory

    .nav-button(value="bookings" @click="navigateTo('/admin/hq/bookings')")
      .nav-content
        v-icon(v-if="activeTab === 'bookings'" :size="iconSize" color="neutral700") $yzi-calendar-solid
        v-icon(v-else :size="iconSize" color="neutral500") $yzi-calendar
        .nav-text(:class="[activeTab === 'bookings' ? 'nav-text--active primary--text' : 'nav-text--default neutral500--text']") Bookings

    .nav-button(value="notifications" @click="navigateTo('/admin/hq/notifications')")
      .nav-content
        v-icon(v-if="activeTab === 'notifications'" :size="iconSize" color="neutral700") $yzi-bell-solid-01
        v-icon(v-else :size="iconSize" color="neutral500") $yzi-bell-01
        .nav-text(:class="[activeTab === 'notifications' ? 'nav-text--active primary--text' : 'nav-text--default neutral500--text']") Notifications

    .nav-button(value="menu" @click="navigateTo('/admin/hq/menu')")
      .nav-content
        v-icon(:size="iconSize" :color="activeTab === 'menu' ? 'primary' : 'neutral500'") $yzi-menu-duocolor-01
        .nav-text(:class="[activeTab === 'menu' ? 'nav-text--active primary--text' : 'nav-text--default neutral500--text']") Menu
</template>

<script>
export default {
  data() {
    return {
      activeTab: 'insights',
      iconSize: 24,
      showNavigation: true,
      lastScrollY: 0,
      scrollThreshold: 10
    }
  },
  watch: {
    '$route.path'() {
      this.updateActiveTab()
    }
  },
  mounted() {
    this.updateActiveTab()
    this.addScrollListener()
  },
  beforeDestroy() {
    this.removeScrollListener()
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route).catch(() => {
      })
    },
    updateActiveTab() {
      const currentPath = this.$route.path
      if (currentPath.includes('/admin/hq/insights') || currentPath.includes('/admin/clinic/insights')) {
        this.activeTab = 'insights'
      } else if (currentPath.includes('/admin/hq/inventory')) {
        this.activeTab = 'inventory'
      } else if (currentPath.includes('/admin/hq/bookings')) {
        this.activeTab = 'bookings'
      } else if (currentPath.includes('/admin/hq/notifications')) {
        this.activeTab = 'notifications'
      } else if (currentPath.includes('/admin/hq/menu')) {
        this.activeTab = 'menu'
      }
    },
    addScrollListener() {
      if (this.$vuetify.breakpoint.mobile) {
        window.addEventListener('scroll', this.handleScroll, {passive: true})
      }
    },
    removeScrollListener() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      if (!this.$vuetify.breakpoint.mobile) return

      const currentScrollY = window.scrollY
      const scrollDifference = Math.abs(currentScrollY - this.lastScrollY)

      // Only trigger if scroll difference is above threshold to prevent jittery behavior
      if (scrollDifference > this.scrollThreshold) {
        if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
          // Scrolling down and past initial threshold - hide navigation
          if (this.showNavigation) {
            this.showNavigation = false
          }
        } else if (currentScrollY < this.lastScrollY) {
          // Scrolling up - show navigation
          if (!this.showNavigation) {
            this.showNavigation = true
          }
        }
        this.lastScrollY = currentScrollY
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-button {
  height: 100%;
  min-width: 0;
  padding-top: 12px;
  padding-bottom: 33px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.nav-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 42px;
  gap: 2px;
}

.nav-text {
  font-size: 12px;
  line-height: 16px;
  height: 16px;

  &--default {
    font-weight: 400; // Regular
  }

  &--active {
    font-weight: 600; // Semi bold
  }
}

.nav.v-bottom-navigation {
  transition: transform 0.3s ease-in-out !important;
  transform: translateY(0) !important;
}

.nav.nav-hidden.v-bottom-navigation {
  transform: translateY(100%) !important;
}

.nav {
  border-top: 1px solid #E5E7EB;
}
</style>
